"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _VsPumpSpeedSettingComponent = _interopRequireDefault(require("./VsPumpSpeedSettingComponent"));
var _index = _interopRequireDefault(require("../../common_features/assets/images/index"));
var _EditAccessoryComponent = _interopRequireDefault(require("../EditAccessoryComponent"));
const SubSteper = _ref => {
  let {
    totalPage,
    currentPage,
    sequence,
    handleNext,
    updatedData,
    count,
    selected,
    value,
    inputValue,
    handleClick,
    handleSaveBtn,
    dateChange,
    handleInputValue,
    setCount,
    list,
    continueBtnDisabled,
    rightNavHeading,
    vsNavHeading,
    vsHeaderText,
    eaHeaderText,
    handleCountBack,
    handleStepBackCount,
    vsSubContent,
    vsContinueBtnTitle,
    continueBtnClick,
    backNavigationScreen,
    eaSubContent,
    inputLabel,
    saveBtnTitle,
    editSliderLabel,
    adjustReplacementText,
    handleCancelbtn,
    saveBtnDisabled,
    handleBtnSelect,
    sliderMin,
    sliderMax,
    inputNumberMin,
    inputNumberMax,
    sliderLeftText,
    sliderRightText,
    minInstallationDate,
    maxInstallationDate,
    modelNumber
  } = _ref;
  const stepComponent = [/*#__PURE__*/_react.default.createElement(_VsPumpSpeedSettingComponent.default, (0, _extends2.default)({}, console.log("heelloooo"), {
    currentPage: currentPage,
    totalPage: totalPage,
    sequence: sequence,
    navHeading: vsNavHeading,
    rightNavHeading: rightNavHeading,
    handleCancle: handleCancelbtn,
    handleBack: handleStepBackCount,
    headerText: vsHeaderText
    // subContent={"Add the pre-filter for the system that is installed."}
    ,
    subContent: vsSubContent,
    list: list,
    handleClick: handleClick
    // selected={selected}
    // continueBtnTitle={"Continue"}
    ,
    continueBtnTitle: vsContinueBtnTitle,
    continueBtnClick: continueBtnClick,
    continueBtnDisabled: continueBtnDisabled,
    handleBtnSelect: handleBtnSelect,
    modelNumber: modelNumber
  })), /*#__PURE__*/_react.default.createElement(_EditAccessoryComponent.default, (0, _extends2.default)({}, console.log("heell"), {
    currentPage: currentPage,
    modelNumber: modelNumber,
    totalPage: totalPage,
    sequence: sequence,
    handleBack: handleCountBack,
    handleCancle: handleCancelbtn,
    leftArrow: _index.default.leftArrow.default,
    backNavigationScreen: backNavigationScreen,
    rightNavHeading: rightNavHeading
    // headerText={`Set Pre-Filter Replacement Reminder`}
    ,
    headerText: eaHeaderText
    // subContent={"When was the pre-filter installed?"}
    ,
    subContent: eaSubContent,
    inputLabel: inputLabel,
    dateChange: dateChange,
    saveBtnTitle: saveBtnTitle,
    saveBtnClick: handleSaveBtn,
    saveBtnDisabled: saveBtnDisabled
    // removeSensorButtonText={"Remove Accessory"}
    // removeBtnClick={handleRemoveBtn}
    // removeBtnDisabled={false}
    ,
    edit: true,
    editSliderLabel: editSliderLabel,
    handleInputValue: handleInputValue,
    inputValue: inputValue,
    sliderMin: sliderMin,
    sliderMax: sliderMax,
    inputNumberMin: inputNumberMin,
    inputNumberMax: inputNumberMax,
    sliderLeftText: sliderLeftText,
    sliderRightText: sliderRightText,
    warningModal: false,
    value: value,
    minInstallationDate: minInstallationDate,
    maxInstallationDate: maxInstallationDate
    // warningModalData={warningModal ? warningModalData : errorModal ? deleteErrorModalData : ""}
    // errorModal={errorModal}
    ,
    isUpdating: false
    // saveErrorModalData={saveErrorModalData}
    ,
    saveErrorModal: false,
    adjustReplacementText: adjustReplacementText
  }))];
  return stepComponent[count];
};
var _default = exports.default = SubSteper;